var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 66,
    viewBox: "0 0 52 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0.5H6.5C2.925 0.5 0.0325007 3.425 0.0325007 7L0 59C0 62.575 2.8925 65.5 6.4675 65.5H45.5C49.075 65.5 52 62.575 52 59V20L32.5 0.5ZM39 52.5H13V46H39V52.5ZM39 39.5H13V33H39V39.5ZM29.25 23.25V5.375L47.125 23.25H29.25Z",
    fill: "#6F7494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.86a5fe6ddfd3a7896377eba0fa99f68f.svg";
export { ForwardRef as ReactComponent };